import { useBreakpoints } from '@Core/hooks'
import { Search } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { useBoolean } from 'ahooks'
import React, { useState } from 'react'
import CoreDialog from '../Dialog/CoreDialog'
import { useNavigate } from 'react-router-dom'
import { QUIZ_ROUTER_EXAM } from '@App/Quiz/Modules/Exam/configs/const'
import clsx from 'clsx'
// import PropTypes from 'prop-types'

const InputSearchExam = ({ className, size = 'small', showInputSearch }) => {
	const [search, setSearch] = useState()
	const [open, { setFalse, setTrue }] = useBoolean()

	const { mobile } = useBreakpoints()
	const navigate = useNavigate()

	const renderDialog = () => {
		return (
			<CoreDialog
				open={open}
				handleClose={setFalse}
				dialogContent={<div className="my-4">{renderInputSearch()}</div>}
			/>
		)
	}

	const renderInputSearch = () => {
		return (
			<TextField
				size={size}
				placeholder="Tìm kiếm đề thi..."
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Search />
						</InputAdornment>
					)
				}}
				onChange={e => setSearch(e.target.value)}
				value={search}
				className={clsx('w-full sm:w-200 md:w-288', className)}
				onKeyDown={e => {
					if (e.key === 'Enter') {
						navigate(`/quiz/${QUIZ_ROUTER_EXAM.explore}?q=${search}`)
					}
				}}
			/>
		)
	}

	if (mobile) {
		return (
			<>
				<IconButton color="primary" onClick={() => setTrue()}>
					<Search />
				</IconButton>
				{renderDialog()}
			</>
		)
	}

	return <div>{renderInputSearch()}</div>
}

// InputSearchExam.defaultProps = {}

// InputSearchExam.propTypes = {}

export default React.memo(InputSearchExam)
